import React from 'react';

interface UpgradeCardProps {
  name: string;
  description: string;
  price: number;
  boostPercent: number;
  isBought: boolean;
  isAvailable: boolean;
  userBalance: number;
  onBuy: () => void;
}

export const UpgradeCard: React.FC<UpgradeCardProps> = ({
  name,
  description,
  price,
  boostPercent,
  isBought,
  isAvailable,
  userBalance,
  onBuy
}) => {
  const canAfford = userBalance >= price;

  return (
    <div 
      className={`
        bg-gradient-to-br from-gray-800 to-gray-900 
        rounded-xl p-4 border-2 
        ${isBought ? 'border-green-500' : isAvailable ? 'border-blue-500' : 'border-gray-700'}
        transition-all duration-300
        ${isBought ? 'opacity-75' : ''}
      `}
    >
      {/* Заголовок */}
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-bold text-white">{name}</h3>
        {isBought && (
          <span className="text-green-400 text-xl">✓</span>
        )}
      </div>

      {/* Описание */}
      <p className="text-gray-400 text-sm mb-3">{description}</p>

      {/* Буст */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-yellow-400 font-bold text-2xl">-{boostPercent}%</span>
        <span className="text-gray-400 text-sm">времени открытия</span>
      </div>

      {/* Цена и кнопка */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <span className="text-blue-400 font-bold text-lg">{price}</span>
          <span className="text-gray-400 text-sm">TON</span>
        </div>

        {isBought ? (
          <button 
            disabled
            className="px-4 py-2 bg-green-600 text-white rounded-lg font-semibold cursor-not-allowed opacity-60"
          >
            Куплено
          </button>
        ) : !isAvailable ? (
          <button 
            disabled
            className="px-4 py-2 bg-gray-700 text-gray-500 rounded-lg font-semibold cursor-not-allowed"
          >
            Недоступно
          </button>
        ) : !canAfford ? (
          <button 
            disabled
            className="px-4 py-2 bg-gray-700 text-gray-500 rounded-lg font-semibold cursor-not-allowed"
          >
            Не хватает
          </button>
        ) : (
          <button 
            onClick={onBuy}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
          >
            Купить
          </button>
        )}
      </div>
    </div>
  );
};

